import { Dropdown } from "react-bootstrap";

const RoutesTable = ({
  routes,
  onView,
  onEdit,
  onDelete,
  isDeleting,
  canManage,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 48 }}>#</th>
            <th style={{ minWidth: 140 }}>Title</th>
            <th style={{ width: 130 }}>Total Distance (km)</th>
            <th style={{ width: 120 }}>Estimated Time</th>
            <th>Description</th>
            <th className="text-center" style={{ width: 72 }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route, index) => {
            const routeId = route._id || route.id;

            return (
              <tr key={routeId || `${index}-${route.title || ""}`}>
                <td>{index + 1}</td>
                <td>{route.title || route.name || "-"}</td>
                <td>{route.total_distance_km ?? "-"}</td>
                <td>{route.estimated_time || "-"}</td>
                <td
                  style={{
                    maxWidth: 420,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {route.description || "-"}
                </td>
                <td className="text-center align-middle">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(route)}
                        disabled={!routeId}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onEdit(route)}
                        disabled={!routeId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onDelete(route)}
                        className="text-danger"
                        disabled={!routeId || isDeleting || !canManage}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RoutesTable;
